import React from 'react';
import { Skeleton } from '@atlaskit/linking-common';
export var AssetsAqlSearchInputSkeleton = function AssetsAqlSearchInputSkeleton() {
  return /*#__PURE__*/React.createElement(Skeleton, {
    width: "100%",
    height: "40px",
    testId: "assets-datasource-modal--aql-search-input-skeleton"
  });
};